module.exports = __webpack_public_path__ + "img/thomasp.9053b18f.jpg";